export default "__VITE_ASSET__45787554__"